import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";
import NormalText from "components/Typography/NormalText";

const ImageWrapper = styled("div")({
  position: "relative",
  maxWidth: "90vw",
  margin: "0 auto",
});

const FullImage = styled("img")({
  display: "block",
  width: "100%",
  height: "auto",
  maxHeight: "90vh",
  borderRadius: "4px",
});

const CloseButton = styled(IconButton)({
  color: "#fff",
  zIndex: 2,
});

const TopSection = styled("div")({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  color: "#fff",
  padding: "8px 16px",
  fontSize: "16px",
  fontWeight: "bold",
  borderTopLeftRadius: "4px",
  borderTopRightRadius: "4px",
  zIndex: 1,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "0.5rem",
});

const TitleOverlay = styled(NormalText)({
  textAlign: "center",
});

const ImageViewer = ({ isOpen, onClose, src, title }) => (
  <Dialog open={isOpen} onClose={onClose} maxWidth={false}>
    <ImageWrapper>
      <TopSection>
        {title && (
          <TitleOverlay className="text-truncate">{title}</TitleOverlay>
        )}
        <CloseButton onClick={onClose} size="small">
          <CloseIcon />
        </CloseButton>
      </TopSection>
      <FullImage src={src} alt={title} />
    </ImageWrapper>
  </Dialog>
);

export default ImageViewer;
